import './styles.styl';

export const medium = {
	name: 'fab-medium',
	variants: ['light', 'dark', 'header'],
	hiddenParts: ['secondaryText'],
};
